
/* ----------------------- Side Cart Cross Sells Ajax ----------------------- */

var $cross_sells_wrapper = $('#side-cart-cross-sells');
var crossSellsLoading = false; // Prevenir múltiples peticiones simultáneas
var crossSellsDebounceTimer = null;
var lastCartHash = ''; // Para evitar recargar si el carrito no cambió

//Added to cart?
jQuery('body').on('added_to_cart', function (event, fragments, cart_hash) {
  // Solo actualizar si el hash del carrito cambió
  if (cart_hash && cart_hash !== lastCartHash) {
    lastCartHash = cart_hash;
    debouncedCrossSells();
  }
});

//Removed from cart?
jQuery('body').on('removed_from_cart', function (event, fragments, cart_hash) {
  // Actualizar hash
  if (cart_hash) lastCartHash = cart_hash;
  
  //Are we removing the last item in the cart?
  if ($('.side-cart ul.cart_list li').length <= 1) {
    //Then remove the cross sells
    $cross_sells_wrapper.fadeOut(200, function() {
      $(this).empty();
    });
  } else {
    debouncedCrossSells();
  }
});

// Debounce para evitar múltiples peticiones rápidas
function debouncedCrossSells() {
  if (crossSellsDebounceTimer) {
    clearTimeout(crossSellsDebounceTimer);
  }
  crossSellsDebounceTimer = setTimeout(function() {
    insertCrossSellsInSidecart();
  }, 300); // Esperar 300ms antes de hacer la petición
}

//Request and insert cross sell items after a product has been added to the side cart via ajax
function insertCrossSellsInSidecart() {
  // Prevenir múltiples peticiones simultáneas
  if (crossSellsLoading) {
    return false;
  }
  
  crossSellsLoading = true;
  
  jQuery.ajax({
    type: 'POST',
    url: ajaxObject.ajax_url, //Defined in setup.php
    data: { 'action': 'get_cross_sells_products' },
    timeout: 10000, // 10 segundos timeout
    beforeSend: function () {
      $cross_sells_wrapper.css('opacity', '0.5');
    },
    error: function (jqXHR, error, errorThrown) {
      console.error('Cross-sells error:', error);
      $cross_sells_wrapper.css('opacity', '1');
    },
    success: function (data) {
      if (data && data.trim() !== '') {
        $cross_sells_wrapper.empty().append(data).css('opacity', '1');
      }
    },
    complete: function() {
      crossSellsLoading = false;
      $cross_sells_wrapper.css('opacity', '1');
    }
  });
  return false;
}

//Block the cross sells container as we add it to the cart
function blockUi() {
  $cross_sells_wrapper.on('click', function (e) {
    if (jQuery(e.target).hasClass('ajax_add_to_cart')) {
      $cross_sells_wrapper.find('ul').block({
        message: '<h6>Adding to cart...</h6>',
        css: { border: '3px solid #fff' },
      });
    }
  });
}
blockUi();



// WEBPACK FOOTER //
// ./scripts/ajax.js